<template>
    <b-row>
        <b-col xs="12" md="6">
            <b-card>
                <b-col cols="12">
                    <b-row>
                        <b-col cols="12" class="heading-icon">
                            <i :class="model.icon"></i> <h4>{{ this.$translateLabel(this.model.label) }} </h4>
                        </b-col>
                        <b-col cols="12">
                            <p>
                            {{ $t('integrations.clerk.description') }}
                            </p>
                        </b-col>
                    </b-row>
                </b-col>

                <StartTrialFooter :integration="model"/>
            </b-card>
        </b-col>
    </b-row>
</template>
<style>
.heading-icon {
    text-align: center;
}
</style>
<script>
import StartTrialFooter from '../../StartTrialFooter'

export default {
    components: {
        StartTrialFooter,
    },
    props: {
        model: {
            Type: Object,
            default: function() {
                return null
            }
        },
        active: {
            type: Boolean,
            default: false
        }
    }
}
</script>
